import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  openTrades: [],
  getOpenTradesSuccess: false,
  getOpenTradesError: null,
  getOpenTradesLoading: false,

  closedTrades: [],
  getClosedTradesSuccess: false,
  getClosedTradesError: null,
  getClosedTradesLoading: false,
};

const ChallengeTradesReducer = createSlice({
  name: "Challenge Trades",
  initialState,
  reducers: {
    getOpenTradesRequest: (state) => {
      state.getOpenTradesLoading = true;
      state.getOpenTradesError = null;
      state.getOpenTradesSuccess = false;
      state.openTrades = [];
    },
    getOpenTradesSuccess: (state, { payload }) => {
      state.openTrades = payload;
      state.getOpenTradesLoading = false;
      state.getOpenTradesError = null;
      state.getOpenTradesSuccess = true;
    },
    getOpenTradesError: (state, { payload }) => {
      state.getOpenTradesLoading = false;
      state.getOpenTradesError = payload;
      state.getOpenTradesSuccess = false;
      state.openTrades = [];
    },

    getClosedTradesRequest: (state) => {
      state.getClosedTradesLoading = true;
      state.getClosedTradesError = null;
      state.getClosedTradesSuccess = false;
      state.closedTrades = [];
    },
    getClosedTradesSuccess: (state, { payload }) => {
      state.closedTrades = payload;
      state.getClosedTradesLoading = false;
      state.getClosedTradesError = null;
      state.getClosedTradesSuccess = true;
    },
    getClosedTradesError: (state, { payload }) => {
      state.getClosedTradesLoading = false;
      state.getClosedTradesError = payload;
      state.getClosedTradesSuccess = false;
      state.closedTrades = [];
    },
  },
});
export const ChallengeTradesActions = ChallengeTradesReducer.actions;

export default ChallengeTradesReducer.reducer;
